<div class="tw-flex tw-flex-col tw-gap-2 sm:tw-gap-5">
  <span class="tw-font-medium">{{ "statementPeriod" | i18n }} *</span>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
    <app-date-picker
      class="tw-w-full"
      [borderType]="'left'"
      [isRequired]="true"
      [dateInputLabel]="'from' | i18n"
      [restrictDirection]="'right'"
      [dateText]="dateRangeFormGroup.get('fromDate').value | date: 'yyyy-MM-dd'"
      [selectedDateRange]="getSelectedDateRange()"
      [hasError]="
        dateRangeFormGroup.get('fromDate').invalid && dateRangeFormGroup.get('fromDate').dirty
      "
      (changeDateEvent)="onDateChange($event, 'fromDate')"
    ></app-date-picker>

    <app-date-picker
      class="tw-w-full"
      [borderType]="'right'"
      [isRequired]="true"
      [dateInputLabel]="'to' | i18n"
      [restrictDirection]="'left'"
      [dateText]="dateRangeFormGroup.get('toDate').value | date: 'yyyy-MM-dd'"
      [selectedDateRange]="getSelectedDateRange()"
      [hasError]="
        dateRangeFormGroup.get('toDate').invalid && dateRangeFormGroup.get('toDate').dirty
      "
      (changeDateEvent)="onDateChange($event, 'toDate')"
    ></app-date-picker>
  </div>
</div>
